import React from "react";
import { ExclamationIcon } from "@heroicons/react/outline";
import Modal from "../../Modal";
import Button from "../../misc/Button";

const DeleteConfirmationModal = ({
  showing,
  closeModal,
  deleteAsync,
  text = "Are you sure you want to delete this?",
  title = "Delete confirmation",
  confirmButtonName = "Delete"
}) => {
  function handleCancel(e) {
    e.preventDefault();
    closeModal();
  }

  return (
    <Modal
      show={showing}
      onClose={handleCancel}
      position="bottom"
      zIndex="z-10"
      panelClassName="overflow-hidden sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
    >
      <DeleteConfirmationContent
        title={title}
        text={text}
        confirmButtonName={confirmButtonName}
        handleCancel={handleCancel}
        deleteAsync={deleteAsync}
      />
    </Modal>
  );
};

function DeleteConfirmationContent({ title, text, confirmButtonName, deleteAsync, handleCancel }) {
  const [deleting, setDeleting] = React.useState(false);

  async function handleConfirm(e) {
    e.preventDefault();
    setDeleting(true);
    try {
      await deleteAsync();
    } catch (error) {
      console.error("Error during deletion:", error);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <>
      <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationIcon className="h-6 w-6 text-red-600" />
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
              {title}
            </h3>
            <div className="mt-2">
              <p className="text-sm leading-5 text-gray-500 whitespace-pre-line">{text}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="py-3 px-6 flex justify-end gap-3 bg-gray-50">
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={deleting}>
          {confirmButtonName}
        </Button>
      </div>
    </>
  );
}

export default DeleteConfirmationModal;
